// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"group-photos_shadow__3lnwq","groupPhotos":"group-photos_groupPhotos__3ReQ5"};